import React, { useState } from "react";

import { useIntl } from "react-intl";
import { useParams, useSearchParams } from "react-router-dom";

import Button, { Link } from "ds/Button";
import * as Sticker from "ds/Sticker";
import * as Toast from "ds/Toast";
import getUrl from "Libs/getUrl";

import * as S from "./styles";

const toastPriorityMap = {
  failed: "error",
  succeeded: "success"
};

const SCASticker: React.FC = () => {
  const intl = useIntl();
  const { organizationId } = useParams();
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");
  const orderId = searchParams.get("orderId");
  const [isOpenToast, setIsOpenToast] = useState(true);
  const toastPriority = toastPriorityMap[status!];
  const hasFailed = status === "failed";

  if (!status || !orderId) return null;

  return (
    <S.Container>
      {hasFailed && (
        <Sticker.Root priority="critical">
          <Sticker.Icon priority="critical" />
          <Sticker.Text>
            {intl.formatMessage<React.ReactNode>(
              { id: "sca.sticker" },
              {
                link: children => (
                  <Link to={intl.formatMessage({ id: "links.sca.learnMore" })}>
                    {children}
                  </Link>
                )
              }
            )}
            <S.ButtonWrapper>
              <Button
                to={getUrl({
                  key: "organization.billing.sca",
                  props: {
                    organizationId: organizationId!,
                    orderId
                  }
                })}
              >
                {intl.formatMessage({ id: "sca.view_transaction" })}
              </Button>
            </S.ButtonWrapper>
          </Sticker.Text>
        </Sticker.Root>
      )}
      <Toast.Provider duration={Infinity}>
        <Toast.Root open={isOpenToast} onOpenChange={setIsOpenToast}>
          <Toast.Icon variant={toastPriority} />
          <Toast.Content>
            <Toast.Title>
              {intl.formatMessage({ id: `sca.toast.${status}.title` })}
            </Toast.Title>
            <S.ToastDescription>
              {intl.formatMessage({ id: `sca.toast.${status}.description` })}
              {hasFailed && (
                <Link
                  to={getUrl({
                    key: "organization.billing.sca",
                    props: {
                      organizationId: organizationId!,
                      orderId
                    }
                  })}
                >
                  {intl.formatMessage({ id: `sca.toast.failed.cta` })}
                </Link>
              )}
            </S.ToastDescription>
            <Toast.Close aria-label="Close" />
          </Toast.Content>
        </Toast.Root>
        <Toast.Viewport />
      </Toast.Provider>
    </S.Container>
  );
};

export default SCASticker;
